(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-form-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scent-option-description')) {
    customElements.define(
      'scent-option-description',
      class ScentOptionDescription extends HTMLElement {
        connectedCallback() {
          this.handleScentClick = this.handleScentClick.bind(this);
          this.addEventListener('click', this.handleScentClick);

          const selectedButton = this.querySelector('[data-scent-description-value].selected');
          this.updateDescription(selectedButton);
          this.updateSelectedLabel(selectedButton);
          this.setupAerro();
          this.setupScentSlider();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleScentClick);
          if (this.scentArrows && this.scentArrows.length) {
            this.scentArrows.forEach(button => button.removeEventListener('click', this.slideScents));
            this.scentTrack.removeEventListener('scroll', this.syncScentArrows);
            this.scentResize.disconnect();
          }
          if (this.aerroForm) {
            this.aerroForm.removeEventListener('click', this.aerroClick, true);
            this.aerroForm.removeEventListener('change', this.aerroChange, true);
          }
        }


        setupScentSlider() {
          this.scentArrows = this.querySelectorAll('[data-scent-scroll]');
          this.scentTrack = this.querySelector('.product-form__option-swatch-series-list');
          if (!this.scentArrows.length || !this.scentTrack) return;
          this.slideScents = event => {
            this.scentTrack.scrollBy({ left: Number(event.currentTarget.dataset.scentScroll) * Math.max(68, this.scentTrack.clientWidth * 0.8), behavior: 'smooth' });
          };
          this.syncScentArrows = () => {
            const max = this.scentTrack.scrollWidth - this.scentTrack.clientWidth;
            this.scentArrows.forEach(button => {
              button.disabled = Number(button.dataset.scentScroll) < 0 ? this.scentTrack.scrollLeft <= 1 : this.scentTrack.scrollLeft >= max - 1;
            });
          };
          this.scentArrows.forEach(button => button.addEventListener('click', this.slideScents));
          this.scentTrack.addEventListener('scroll', this.syncScentArrows, { passive: true });
          this.scentResize = new ResizeObserver(this.syncScentArrows);
          this.scentResize.observe(this.scentTrack);
          this.syncScentArrows();
        }

        setupAerro() {
          this.aerroForm = this.closest('form[data-product-handle="aerro-scent-machine"]');
          if (!this.aerroForm) return;
          this.aerroSelect = this.aerroForm.querySelector('select[name="options[Aerro]"]');
          this.scentSelect = this.aerroForm.querySelector('select[name="options[Scent]"]');
          if (!this.aerroSelect || !this.scentSelect) return;
          this.aerroBenefits = this.aerroForm.querySelector('[data-aerro-machine-benefits]');
          if (!this.aerroBenefits) {
            const description = this.aerroForm.querySelector('.product__description');
            const benefits = description ? [...description.querySelectorAll('p')].filter(p => p.textContent.trim().startsWith('✅')) : [];
            const machineOption = this.aerroSelect.closest('.product-form__option');
            if (benefits.length && machineOption) {
              this.aerroBenefits = document.createElement('div');
              this.aerroBenefits.className = 'aerro-machine-benefits rte';
              this.aerroBenefits.dataset.aerroMachineBenefits = '';
              benefits.forEach(point => this.aerroBenefits.appendChild(point));
              machineOption.insertAdjacentElement('afterend', this.aerroBenefits);
            }
          }
          this.aerroVariants = JSON.parse(this.aerroForm.querySelector('[data-variant-json]').textContent);
          this.aerroClick = (event) => {
            const button = event.target.closest('[data-button]');
            if (button && button.parentElement.contains(this.aerroSelect)) {
              this.syncAerro(button.getAttribute('aria-label'));
            }
          };
          this.aerroChange = (event) => {
            if (event.target === this.aerroSelect) this.syncAerro(this.aerroSelect.value);
          };
          this.aerroForm.addEventListener('click', this.aerroClick, true);
          this.aerroForm.addEventListener('change', this.aerroChange, true);
          this.syncAerro(this.aerroSelect.value);
        }

        syncAerro(type) {
          const machineOnly = type === 'Machine Only';
          if (this.aerroBenefits) this.aerroBenefits.hidden = !machineOnly;
          const section = this.closest('.product-form__option');
          section.style.display = machineOnly ? 'none' : '';
          const warrantySelect = this.aerroForm.querySelector('select[name="options[Warranty]"]');
          const warrantySection = warrantySelect && warrantySelect.closest('.product-form__option');
          if (warrantySection) warrantySection.style.display = type === 'Fragrance Oils' ? 'none' : '';
          const current = this.scentSelect.value;
          if (machineOnly && current !== 'Machine Only') this.previousScent = current;
          const candidates = this.aerroVariants.filter(variant => variant.option1 === type);
          const desired = machineOnly ? 'Machine Only' : current !== 'Machine Only' ? current : this.previousScent;
          const variant = candidates.find(variant => variant.available && variant.option2 === desired)
            || candidates.find(variant => variant.available)
            || candidates.find(variant => variant.option2 === desired)
            || candidates[0];
          if (!variant) return;
          if (type === 'Fragrance Oils' && warrantySelect && variant.option3) {
            warrantySelect.value = variant.option3;
            warrantySection.querySelectorAll('[data-button]').forEach(button => {
              button.classList.toggle('selected', button.getAttribute('aria-label') === variant.option3);
            });
          }
          this.scentSelect.value = variant.option2;
          let selected;
          this.querySelectorAll('[data-scent-description-value]').forEach(button => {
            const active = button.getAttribute('aria-label') === variant.option2;
            button.classList.toggle('selected', active);
            if (active) selected = button;
          });
          if (selected) {
            this.updateDescription(selected);
            this.updateSelectedLabel(selected);
          }
          if (current !== variant.option2) {
            this.scentSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        handleScentClick(event) {
          const button = event.target.closest('[data-scent-description-value]');

          if (button && this.contains(button)) {
            this.updateDescription(button);
            requestAnimationFrame(() => this.updateSelectedLabel(button));
          }
        }

        updateDescription(button) {
          const output = this.querySelector('[data-scent-description-output]');

          if (!button || !output) {
            return;
          }

          const description = button.dataset.scentDescriptionValue || '';
          output.textContent = description;
          output.hidden = description.length === 0;
        }

        updateSelectedLabel(button) {
          const optionButtons = this.closest('[data-option-buttons]');

          if (!button || !optionButtons) {
            return;
          }

          const selectedLabel = optionButtons.querySelector('[data-option-selected]');

          if (!selectedLabel) {
            return;
          }

          const compactScentLabel = this.dataset.scentLabelLayout === 'compact';
          const scentName = button.getAttribute('aria-label') || '';
          const seriesName = button.dataset.scentSeriesValue || '';
          let selectedSwatch = optionButtons.querySelector('[data-selected-scent-swatch]');

          if (!selectedSwatch) {
            selectedSwatch = document.createElement('span');
            selectedSwatch.className = 'product-form__selected-scent-swatch';
            selectedSwatch.dataset.selectedScentSwatch = '';
            selectedSwatch.setAttribute('aria-hidden', 'true');
            selectedLabel.insertAdjacentElement(compactScentLabel ? 'afterend' : 'beforebegin', selectedSwatch);
          }

          selectedSwatch.style.backgroundImage = button.style.backgroundImage;
          selectedSwatch.style.backgroundColor = button.style.backgroundColor;
          selectedLabel.textContent = scentName;
          let seriesBadge = optionButtons.querySelector('[data-scent-series-badge]');
          if (compactScentLabel) {
            if (seriesBadge) seriesBadge.remove();
            return;
          }

          if (!seriesBadge) {
            seriesBadge = document.createElement('span');
            seriesBadge.className = 'product-form__scent-series-badge';
            seriesBadge.dataset.scentSeriesBadge = '';
            selectedLabel.insertAdjacentElement('afterend', seriesBadge);
          }

          seriesBadge.textContent = seriesName;
          seriesBadge.dataset.series = seriesName;
          seriesBadge.hidden = seriesName.length === 0;
        }
      }
    );
  }


(() => {
    const englishCountryInnImages = [
      {
        src: 'https://lh3.googleusercontent.com/d/101qteXj3VOeKXuiRBWduL3NimXWSJq-3=w1600',
        alt: 'English Country Inn 50ml reed diffuser'
      },
      {
        src: 'https://lh3.googleusercontent.com/d/16kCrCpKkWVarp4n7Wgo1IdPM20rtd30A=w1600',
        alt: 'English Country Inn 50ml reed diffuser box'
      },
      {
        src: 'https://lh3.googleusercontent.com/d/1GWjG093EBVAlKPIZAsjBwoasmy48Qub2=w1600',
        alt: 'English Country Inn 180ml reed diffuser box'
      },
      {
        src: 'https://lh3.googleusercontent.com/d/10oveCDk7ZRom0I8WNE47gTk8BTnfImsx=w1600',
        alt: 'English Country Inn 180ml reed diffuser'
      }
    ];

    function setEnglishCountryInnGallery(container, active) {
      if (!container) return;

      let gallery = container.querySelector(':scope > .eci-drive-gallery');

      if (!gallery) {
        gallery = document.createElement('div');
        gallery.className = 'eci-drive-gallery';
        gallery.setAttribute('aria-label', 'English Country Inn product images');
        gallery.innerHTML =
          '<div class="eci-drive-gallery__main">' +
            '<img class="eci-drive-gallery__main-image" width="1600" height="1600" alt="">' +
            '<button class="eci-drive-gallery__arrow eci-drive-gallery__arrow--previous" type="button" aria-label="Previous image">&#8592;</button>' +
            '<button class="eci-drive-gallery__arrow eci-drive-gallery__arrow--next" type="button" aria-label="Next image">&#8594;</button>' +
          '</div>' +
          '<div class="eci-drive-gallery__thumbnails" role="list"></div>';

        const nativeMedia = container.querySelector(':scope > .product__media');
        container.insertBefore(gallery, nativeMedia || container.firstChild);

        const mainImage = gallery.querySelector('.eci-drive-gallery__main-image');
        const thumbnails = gallery.querySelector('.eci-drive-gallery__thumbnails');
        let currentIndex = 0;

        const showImage = (index) => {
          currentIndex = (index + englishCountryInnImages.length) % englishCountryInnImages.length;
          const image = englishCountryInnImages[currentIndex];
          mainImage.src = image.src;
          mainImage.alt = image.alt;
          thumbnails.querySelectorAll('button').forEach((button, buttonIndex) => {
            button.setAttribute('aria-current', buttonIndex === currentIndex ? 'true' : 'false');
          });
        };

        englishCountryInnImages.forEach((image, index) => {
          const button = document.createElement('button');
          button.className = 'eci-drive-gallery__thumbnail';
          button.type = 'button';
          button.setAttribute('role', 'listitem');
          button.setAttribute('aria-label', 'View ' + image.alt);
          button.innerHTML = '<img src="' + image.src + '" alt="" width="1600" height="1600" loading="lazy">';
          button.addEventListener('click', () => showImage(index));
          thumbnails.appendChild(button);
        });

        gallery.querySelector('.eci-drive-gallery__arrow--previous').addEventListener('click', () => showImage(currentIndex - 1));
        gallery.querySelector('.eci-drive-gallery__arrow--next').addEventListener('click', () => showImage(currentIndex + 1));
        showImage(0);
      }

      container.classList.toggle('eci-drive-gallery-active', active);
    }

    function updateEnglishCountryInnGallery(optionValue) {
      if (!window.location.pathname.includes('/products/reed-diffuser')) return;
      const mediaContainer = document.querySelector('.product__media-container');
      const selectedButton = document.querySelector('[data-option-value].selected');
      const selectedValue = optionValue || (selectedButton ? selectedButton.dataset.optionValue : '');
      setEnglishCountryInnGallery(mediaContainer, selectedValue === 'English Country Inn');
    }

    document.addEventListener('click', (event) => {
      const optionButton = event.target.closest('[data-option-value]');
      if (!optionButton) return;
      updateEnglishCountryInnGallery(optionButton.dataset.optionValue);
    });

    document.addEventListener('DOMContentLoaded', () => updateEnglishCountryInnGallery());
    document.addEventListener('shopify:section:load', () => updateEnglishCountryInnGallery());

    if (document.readyState !== 'loading') {
      updateEnglishCountryInnGallery();
    }
  })();


  (() => {
    const updateSizeDescription = (wrapper, value) => {
      const output = wrapper.querySelector('[data-size-description-output]');
      if (!output) return;
      const size = value.replace(' Reed Diffuser', '').trim();
      output.textContent = output.getAttribute('data-duration-' + size) || '';
      output.hidden = !output.textContent;
    };
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.product-form__chip');
      const wrapper = button && button.closest('[data-reed-size-option]');
      if (wrapper) updateSizeDescription(wrapper, button.dataset.optionValue || button.getAttribute('aria-label') || '');
    });
    document.addEventListener('change', (event) => {
      const select = event.target.closest('select');
      const wrapper = select && select.closest('[data-reed-size-option]');
      if (wrapper) updateSizeDescription(wrapper, select.value);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
